package com.eladfinish.bible.contest.screens.completeVerse.usecases

import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.utils.replaceKtivWithQriNew

/**
 * Debug-only utility that shows acceptable completion options for a verse.
 *
 * Outputs:
 *  1. The verse source (e.g. "(בראשית א, א)")
 *  2. Word-versions for each word the user must complete
 *  3. Word-versions derived from the user's typed reference,
 *     parsed against the verse's QRI text.
 */
class GetAllOptionsToCompleteUseCase(
    private val getWordVersionsUseCase: GetWordVersionsUseCase,
) {

    private fun wordVersionsList(
        words: List<String>,
    ): String {
        return words.joinToString(separator = "\n") { getWordVersionsUseCase(sourceWord = it).toString() }
    }

    operator fun invoke(
        searchResult: VerseUiModel,
        verseRef: String,
        allWords: List<String>,
    ): String {
        var output = ""
        try {
            output += searchResult.source + "\n"
            output += wordVersionsList(allWords)

            // Parse verseRef against the current verse text to show word-version alternatives.
            val qriText = searchResult.text
                .replaceKtivWithQriNew()
                .replaceRegex(regex = " ׀", replacement = "׀")

            val referenceWords = qriText.trim()
                .replace(StringConstants.MAKAF.toString(), "${StringConstants.MAKAF} ")
                .split(" ")
                .filter { it.isNotBlank() }

            if (referenceWords.isNotEmpty()) {
                output += "\n$qriText\n"
                output += wordVersionsList(referenceWords)
            }
        } catch (e: Exception) {
            AppCrashlytics.logException(e)
            output += "\n$e\n"
        }
        return output
    }
}
